<template>
    <grid-select 
      v-model="selectedValue" 
      :label="label" 
      :defaultLabel="defaultLabel"
      valueField="id"
      labelField="name"
      :placeholder="placeholder"
      :size="size" 
      :multiple="multiple"
      :disabled="disabled"
      :searchItems="[{field: 'name', title: '岗位名称'}, {field: 'dept_id', title: '部门', ctype: 'dept', valueField: 'id'}, {field: 'sub_dept_id', title: '科室', ctype: 'dept', valueField: 'id'}, {field: 'turn_id', title: '学期', ctype: 'turn', valueField: 'no'}, {field: 'apply_properties', title: '岗位性质', ctype: 'dict', cvalue: 'wk_apply_properties'}]"
      :gridItems="[{field: 'name', title: '岗位名称'}, {field: 'dept_name', title: '部门'}, {field: 'sub_dept_name', title: '科室'}, {field: 'turn_name', title: '学期'}, {field: 'apply_properties', title: '岗位性质', ctype: 'dict', cvalue: 'wk_apply_properties'}]"
      :getDataList="listWkPost"
      @change="handleChange"
    ></grid-select>
  </template>
  
  <script>
  import { listWkPost } from "@/api/wk/wk_post";
  
  export default {
    name: 'wk-post-select',
    props: {
      value: {
        type: [String, Number],
        default: () => { return null }
      },
      label: {
        type: String,
        default: () => { return null }
      },
      defaultLabel: {
        type: String,
        default: () => { return null }
      },
      placeholder: {
        type: String,
        default: () => { return '请选择' }
      },
      size: {
        type: String,
        default: () => { return 'medium' }
      },
      multiple: {
        type: Boolean,
        default: () => { return true }
      },
      disabled: {
        type: Boolean,
        default: () => { return false }
      }
    },
    data() {
      return {
        listWkPost: listWkPost,
        selectedValue: this.value
      }
    },
    created() {
    },
    methods: {
      handleChange(e1, e2) {
        this.$emit('input', e1)
        this.$emit('change', e1, e2)
      }
    },
    watch: {
      value(val) {
        this.selectedValue = val
      }
    }
  }
  </script>
  